import { Bundle, MiscellaneousItem, Truckload } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function getAll() {
  return DesignService.get<readonly Truckload[]>(`truckloads`);
}

export function getActive() {
  return DesignService.get<readonly Truckload[]>(`truckloads/active`);
}

export function getForProject(projectGuid: string) {
  return DesignService.get<readonly Truckload[]>(`truckloads/forProject/${projectGuid}`);
}

export function getForGuids(truckloadGuids: readonly string[]) {
  return DesignService.post<readonly Truckload[]>(`truckloads/getForGuids`, { data: truckloadGuids });
}

export function insert(
  trailerGuid: string | null,
  truckDriverGuid: string | null,
  dateShipped: Date | null,
  miscellaneousItems: readonly MiscellaneousItem[],
) {
  return DesignService.post<Truckload>('truckloads', {
    data: { trailerGuid, truckDriverGuid, dateShipped, miscellaneousItems },
  });
}

export function update(truckload: Truckload) {
  return DesignService.put<void>('truckloads', { data: truckload });
}

export function remove(truckloadGuid: string) {
  return DesignService.delete<readonly Bundle[]>(`truckloads/${truckloadGuid}`);
}

export function downloadBillOfLading(
  truckloadGuid: string,
  salesperson: string | null,
  soldToAddress: string | null,
  shipToAddress: string | null,
) {
  return DesignService.fetchFile('truckloads/downloadBillOfLading', {
    post: true,
    data: { truckloadGuid, salesperson, soldToAddress, shipToAddress },
  });
}
